<template>
    <div class="layout__padding-clear">
        <div class="colour__background-white">
            <div class="text__align-center text__colour-white layout__margin__bottom-25px">
                <div class="layout__padding-clear layout__width-50 layout__padding-40px-0 layout__border__bottom-light-teal-1px">
                    <h2 class="text__colour-teal">Get a Price</h2>
                    <div class="layout__padding-20-0 text__size-18 text__colour-grey">Fill in a few quick details and
                        receive an instant price, valid for 30 days
                    </div>
                </div>
            </div>

            <div class="layout__padding-clear layout__width-800px">
                <Stepguide v-bind:stepCount="0"></Stepguide>
                <h3 class="text__colour-teal text__align-center layout__padding-20-0">Select product type</h3>
                <div class="layout__width-100 text__align-center">
                    <div class="">
                        <el-radio-group v-model="activeComponent" :max="1"
                                        class="layout__padding-clear layout__width-100">
                            <el-radio-button class="layout__width-150px layout__margin-10-0" label="fcode"
                                             :key="'fcode'" v-if="this.showFcodeChoice">
                                <div class="text__colour-teal layout__padding-10-0">Fcode</div>
                            </el-radio-button>
                            <el-radio-button class="layout__width-150px layout__margin-10-0" label="iso" :key="'iso'">
                                <div class="text__colour-teal layout__padding-10-0">Paper Size</div>
                            </el-radio-button>
                            <el-radio-button class="layout__width-150px layout__margin-10-0" label="sizes"
                                             :key="'sizes'">
                                <div class="text__colour-teal layout__padding-10-0-10-0">Product Size</div>
                            </el-radio-button>
                        </el-radio-group>
                    </div>
                </div>

                <div v-if="activeComponent === 'fcode'">
                    <!--<h4 class="text__align-center text__colour-teal">Select Product Dimensions</h4>-->
                    <el-form :model="fCode" status-icon ref="fcode" :rules="rules" class="layout__padding-clear">
                        <div class="layout__width-100 layout__padding-25-0">
                            <p class="layout__padding-8-0">Product Selection</p>
                            <el-form-item prop="fCode">
                                <el-select v-model="fCode.fCode" clearable filterable placeholder="Select or Type Product"
                                           value-key="code">
                                    <el-option
                                            v-for="fCode in fCodes"
                                            :key="fCode.code"
                                            :label="fCode.code"
                                            :value="fCode">{{fCode.code}} - {{fCode.description}}
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>


                        <div class="layout__margin-25-0">
                            <el-button class="button__base layout__width-200px button-red layout__position-center"

                                       v-on:click="findProductByFcode('fcode')">Search
                            </el-button>
                        </div>
                    </el-form>
                </div>

                <div v-if="activeComponent === 'iso'">
                    <el-form :model="iso" status-icon ref="iso" :rules="rules" class="layout__padding-clear">
                        <div class="layout__width-100 layout__padding-25-0">
                            <p class="layout__padding-8-0">Product Size<span class="text__colour-red">*</span></p>
                            <el-form-item prop="paperOption">
                                <el-select v-model="iso.paperOption" clearable filterable
                                           placeholder="Select or Type Product Size" value-key="name"
                                           v-on:change="selectedISO()">
                                    <el-option
                                            v-for="paperOption in paperOptions"
                                            :key="paperOption.name"
                                            :label="paperOption.name"
                                            :value="paperOption">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>

                        <div class="layout__width-100">

                            <p class="layout__padding-8-0">Page Count<span class="text__colour-red">*</span></p>
                            <el-form-item prop="page">
                                <el-select v-model="iso.page" clearable filterable
                                           placeholder="Select Page Count">
                                    <el-option
                                            v-for="page in pages"
                                            :key="page"
                                            :label="page"
                                            :value="page">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="layout__padding-clear layout__padding-20px">
                            <el-button class="button__base layout__width-200px button-red layout__position-center"
                                       v-on:click="findProductByISO('iso')">Search
                            </el-button>
                        </div>
                    </el-form>
                </div>

                <div v-if="activeComponent === 'sizes'">
                    <el-form :model="manual" status-icon ref="manual" :rules="rules" class="layout__padding-clear">
                        <div class="layout__width-100 layout__padding-25-0">
                            <p class="layout__padding-8-0">Product Width (mm)<span class="text__colour-red">*</span></p>
                            <el-form-item prop="manualWidth">
                                <el-select v-model="manual.manualWidth" filterable clearable
                                           placeholder="Select Width" v-on:change="selectedWidth()">
                                    <el-option
                                            v-for="width in widths"
                                            :key="width"
                                            :label="width"
                                            :value="width">{{width}}mm
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>

                        <div class="layout__width-100">
                            <p class="layout__padding-8-0">Product Height (mm)<span class="text__colour-red">*</span>
                            </p>
                            <el-form-item prop="manualHeight">
                                <el-select v-model="manual.manualHeight" filterable clearable
                                           placeholder="Select Height" v-on:change="selectedHeight()">
                                    <el-option
                                            v-for="height in heights"
                                            :key="height"
                                            :label="height"
                                            :value="height">{{height}}mm
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>

                        <div class="layout__width-100 layout__padding-25-0">
                            <p class="layout__padding-8-0">Page Count<span class="text__colour-red">*</span></p>
                            <el-form-item prop="manualPage">
                                <el-select v-model="manual.manualPage" filterable clearable
                                           placeholder="Select Page Count" v-on:change="selectedHeight()">
                                    <el-option
                                            v-for="manualPage in manualPages"
                                            :key="manualPage"
                                            :label="manualPage"
                                            :value="manualPage">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>

                        <div class="layout__padding-clear layout__padding-20px">
                            <el-button class="button__base layout__width-200px button-red layout__position-center"
                                       :disabled="this.width == '' || this.height == '' || this.manualPage == ''"
                                       v-on:click="findProductByWidthHeight('manual')">Search
                            </el-button>
                        </div>
                    </el-form>
                </div>

            </div>
        </div>
    </div>


</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';
    import Router from '../../../router';
    import Stepguide from "../../../components/tools/quote/StepGuide";

    export default {
        name: "generateaquote",
        props: {},
        components: {
            Stepguide
        },
        mixins: [axios, dataFormatter, backing],
        data() {
            const validatePaperOption = (rule, value, callback) => {
                if (this.iso.paperOption == null) {
                    callback(new Error('Paper option required'));
                } else {
                    callback();
                }
            };
            const validatefCode = (rule, value, callback) => {
                if (this.fCode.fCode == null) {
                    callback(new Error('fCode required'));
                } else {
                    callback();
                }
            };
            return {
                activeComponent: 'iso',
                showFcodeChoice: false,
                fCode: {
                    fCode: null
                },
                fCodes: [],
                paperOptions: [],
                iso: {
                    paperOption: null,
                    page: '',
                },
                manual: {
                    width: '',
                    height: '',
                    manualPage: '',
                },
                widths: [],
                heights: [],
                manualPages: [],
                pages: [],
                activeTab: 'product',
                tabPosition: 'top',
                source: '',
                quoteJob: {},
                products: [],
                productsHolding: [],
                productSelection: '',
                rules: {
                    manualWidth: [{
                        required: true, message: 'Width required', trigger: 'blur'
                    }],
                    manualHeight: [{
                        required: true, message: 'Height required', trigger: 'blur'
                    }],
                    manualPage: [{
                        required: true, message: 'Page count required', trigger: 'blur'
                    }],
                    paperOption: [{
                        validator: validatePaperOption
                    }],
                    page: [{
                        required: true, message: 'Page count required', trigger: 'blur'
                    }],
                    fCode: [{
                        validator: validatefCode
                    }],
                }
            }
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_quoteJob', JSON.stringify(this.quoteJob));
        },
        created() {
            if (JSON.parse(window.sessionStorage.getItem('_quoteJob'))) {
                this.quoteJob = JSON.parse(window.sessionStorage.getItem('_quoteJob'))
            } else {

                const getQuoteJob = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/quotes`

                console.log(getQuoteJob)

                Axios.post(getQuoteJob, {}, this.returnHeaderNoToken())
                    .then(response => {
                        this.quoteJob = response.data
                    })
            }


            if (JSON.parse(this.returnCookie('_role'))) {

            }


            if (JSON.parse(this.returnCookie('_role')) !== null && (!JSON.parse(this.returnCookie('_role')).includes('Customer'))) {
                this.showFcodeChoice = true
            }

            const findAllFcode = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindAllProdStyles`

            Axios.get(findAllFcode)
                .then(response => {
                    console.log('find all fcode call')
                    console.log(response)
                    this.fCodes = response.data.sort(function (a, b) {
                        return a - b
                    })
                })

            const findWeight = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindAllWidths`

            console.log(findWeight)

            Axios.get(findWeight)
                .then(response => {
                    console.log(response)
                    this.widths = response.data.sort(function (a, b) {
                        return a - b
                    })
                })


            const findISO = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/GetISO216`

            console.log(findISO)

            Axios.get(findISO)
                .then(response => {
                    console.log('ISO')
                    this.paperOptions = response.data.papersizes.sort(function (a, b) {
                        return a - b
                    })
                })
        },
        methods: {
            findProductByFcode(fcode) {


                this.$refs[fcode].validate((valid) => {
                    if (valid) {


                        console.log('starting via fCode')
                        // todo moves straight to the selection screen
                        this.quoteJob.printJobSpec.pageWidth = this.fCode.fCode.pageWidth
                        this.quoteJob.printJobSpec.pageHeight = this.fCode.fCode.pageHeight
                        this.quoteJob.printJobSpec.pageCount = this.fCode.fCode.pageCount


                        const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindProductsAsync`

                        const getProducts = {
                            "id": 0,
                            "fCode": "",
                            "stockType": "string",
                            "pageWidth": this.quoteJob.printJobSpec.pageWidth,
                            "pageHeight": this.quoteJob.printJobSpec.pageHeight,
                            "actualPageWidth": 0,
                            "actualPageHeight": 0,
                            "pageOrientation": "string",
                            "stockWeight": "string",
                            "lamination": "string",
                            "pageCount": this.quoteJob.printJobSpec.pageCount,
                            "quantity": 0
                        }

                        console.log('making products call')
                        console.log(getProducts)
                        Axios.post(url, getProducts, this.returnHeaderNoToken())
                            .then(response => {
                                console.log(response)
                                this.products = response.data
                                window.sessionStorage.setItem('_quoteProducts', JSON.stringify(this.products));
                                console.log('products')
                                console.log(this.products)
                                this.next()
                            })

                    } else {
                        return false;
                    }
                })

            },
            findProductByISO(iso) {

                this.$refs[iso].validate((valid) => {
                    if (valid) {


                        console.log('starting with the paperOption and the page count')

                        this.quoteJob.printJobSpec.pageWidth = this.iso.paperOption.width
                        this.quoteJob.printJobSpec.pageHeight = this.iso.paperOption.height
                        this.quoteJob.printJobSpec.pageCount = this.iso.page


                        const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindProductsAsync`

                        const getProducts = {
                            "id": 0,
                            "fCode": "",
                            "stockType": "string",
                            "pageWidth": this.quoteJob.printJobSpec.pageWidth,
                            "pageHeight": this.quoteJob.printJobSpec.pageHeight,
                            "actualPageWidth": 0,
                            "actualPageHeight": 0,
                            "pageOrientation": "string",
                            "stockWeight": "string",
                            "lamination": "string",
                            "pageCount": this.quoteJob.printJobSpec.pageCount,
                            "quantity": 0
                        }

                        console.log('making products call')
                        console.log(getProducts)
                        Axios.post(url, getProducts, this.returnHeaderNoToken())
                            .then(response => {
                                console.log(response)
                                this.products = response.data
                                window.sessionStorage.setItem('_quoteProducts', JSON.stringify(this.products));
                                console.log('products')
                                console.log(this.products)
                                this.next()
                            })

                    } else {
                        return false;
                    }
                })

            },
            findProductByWidthHeight(manual) {

                this.$refs[manual].validate((valid) => {
                    if (valid) {

                        // } else if (this.width != '' && this.height != '' && this.manualPage != '') {
                        console.log('starting with the paperOption and the page count')

                        // todo pull width height count find to get a list of products

                        // todo show products selections

                        this.quoteJob.printJobSpec.pageWidth = this.manual.manualWidth
                        this.quoteJob.printJobSpec.pageHeight = this.manual.manualHeight
                        this.quoteJob.printJobSpec.pageCount = this.manual.manualPage

                        // }

                        // if (this.fCode != null || this.fCode != '') {

                        // }

                        const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindProductsAsync`

                        const getProducts = {
                            "id": 0,
                            "fCode": "",
                            "stockType": "string",
                            "pageWidth": this.quoteJob.printJobSpec.pageWidth,
                            "pageHeight": this.quoteJob.printJobSpec.pageHeight,
                            "actualPageWidth": 0,
                            "actualPageHeight": 0,
                            "pageOrientation": "string",
                            "stockWeight": "string",
                            "lamination": "string",
                            "pageCount": this.quoteJob.printJobSpec.pageCount,
                            "quantity": 0
                        }

                        console.log('making products call')
                        console.log(getProducts)
                        Axios.post(url, getProducts, this.returnHeaderNoToken())
                            .then(response => {
                                console.log(response)
                                this.products = response.data
                                window.sessionStorage.setItem('_quoteProducts', JSON.stringify(this.products));
                                console.log('products')
                                console.log(this.products)
                                this.next()
                            })

                    } else {
                        return false;
                    }
                })

            },
            selectedWidth() {
                const getHeights = {
                    "id": 0,
                    "fCode": "string",
                    "productRef": "string",
                    "name": "string",
                    "description": "string",
                    "stockType": "string",
                    "pageWidth": this.manual.manualWidth,
                    "pageHeight": 0,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": "string",
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                console.log('getHeights')
                console.log(getHeights)

                const findWeight = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindHeightsForWidth`

                console.log(findWeight)

                Axios.post(findWeight, getHeights, this.returnHeaderNoToken())
                    .then(response => {
                        console.log(response)
                        this.heights = response.data.sort(function (a, b) {
                            return a - b
                        })
                        this.manual.manualHeight = ''
                        this.manual.manualPage = ''
                    })

            },
            selectedHeight() {

                // todo pull the page count for the width and height

                const getManualPages = {
                    "id": 0,
                    "fCode": "string",
                    "productRef": "string",
                    "name": "string",
                    "description": "string",
                    "stockType": "string",
                    "pageWidth": this.manual.manualWidth,
                    "pageHeight": this.manual.manualHeight,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": "string",
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                console.log('getPages')
                console.log(getManualPages)

                const findPages = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindPageCountForSize`

                console.log(findPages)

                Axios.post(findPages, getManualPages, this.returnHeaderNoToken())
                    .then(response => {
                        console.log(response)
                        this.manualPages = response.data.sort(function (a, b) {
                            return a - b
                        })
                        // this.height = ''
                    })

            },
            selectedISO() {
                const getPages = {
                    "id": 0,
                    "fCode": "string",
                    "productRef": "string",
                    "name": "string",
                    "description": "string",
                    "stockType": "string",
                    "pageWidth": this.iso.paperOption.width,
                    "pageHeight": this.iso.paperOption.height,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": "string",
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                this.quoteJob.printJobSpec.pageWidth = this.iso.paperOption.width
                this.quoteJob.printJobSpec.pageHeight = this.iso.paperOption.height

                console.log('getPages')
                console.log(getPages)

                const findPages = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindPageCountForSize`

                console.log(findPages)

                Axios.post(findPages, getPages, this.returnHeaderNoToken())
                    .then(response => {
                        console.log(response)
                        this.pages = response.data.sort(function (a, b) {
                            return a - b
                        })
                        this.iso.page = ''
                    })
            },
            selectProduct(product) {

                let selectedProduct = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/quotes/` + this.quoteJob.id

                console.log(selectedProduct)

                const selectProduct = {
                    "printJobSpec": {
                        "fCode": product.code,
                        "name": product.name,
                        "description": product.description,
                        "pageWidth": this.quoteJob.printJobSpec.pageWidth,
                        "pageHeight": this.quoteJob.printJobSpec.pageHeight,
                        "pageCount": this.quoteJob.printJobSpec.pageCount
                    }
                }
                console.log('SELECT PRODUCT')
                console.log(selectProduct)

                Axios.put(selectedProduct, selectProduct)
                    .then(response => {
                        console.log(response)
                        this.quoteJob = response.data

                        this.next()
                        // const url = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/quotes/` + this.quoteJob.id
                        //
                        //
                        // const emptyJobSpec = {
                        //     "printJobSpec": {
                        //     }
                        // }
                        //
                        // Axios.put(url, emptyJobSpec, this.returnHeaderUsingToken())
                        //     .then(response => {
                        //         console.log(response)
                        //         this.quoteJob = response.data
                        //
                        //         this.next()
                        //     })


                    })
            },
            next() {
                window.sessionStorage.removeItem('_quoteSummary')
                Router.push({
                    name: '/get-price/selections',
                    params: {
                        quoteJob: this.quoteJob,
                        products: this.products
                    }
                });

            }
        },
    };
</script>
